export const URL = 'https://appdata.dentpedia.ro'
export const DEVICEKEY = 'AAAAcvWt63Y:APA91bG35IlRJ_Vzh3gkaBbdZkYwTpcYC7KQ2mpNdXKjECgmdjBkOdp5nBgLob81kPf46bKytxQ67Qo6DP7E-NGg2nDn1K9sI8nwXL22_yE5t6DroavKlbN4JUQdRc0jK-hZSdumrOa-'



// WEBPACK FOOTER //
// ./src/variables/index.js